import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import store from "./app/store";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import * as serviceWorker from "./serviceWorker";
import "./i18n";

const getEnvironment = () => {
  if (window.location.hostname === "localhost") {
    return "local";
  }

  return process.env.REACT_APP_ENV || "development";
};

Sentry.init({
  dsn: "https://32a35d82d9915d1c6989f0bc8dfc8101@o4510465098383360.ingest.de.sentry.io/4512368747479120",
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  environment: getEnvironment(),
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
